import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const updatePreviewPhoneNumber = async (domain: string, phoneNumber: string | null, country: string | null, phoneWithPrefix: string | null): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `preview-phone-number`,
        method: 'POST',
        params: { phone: phoneNumber, country: country, phoneWithPrefix: phoneWithPrefix },
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}